var PRIVACY_STATEMENT_LINK_URL = 'https://aka.ms/AppSourcePrivacyStatement';

export { PRIVACY_STATEMENT_LINK_URL };
